<template>
  <div :class="['m-bubble-message', `direction-${direction}`]">
    <div class="el-avatar-box">
      <el-avatar @click.native="clickBtnHandle('showInfo')" shape="square" icon="el-icon-user" :src="info.avatar"></el-avatar>
      <div class="tool-box">
        <svg-icon name="at" title="@Ta" @click.native="clickBtnHandle('at')"></svg-icon>
        <report-btn :info="info"></report-btn>
      </div>
      <span v-if="!info.isAnonymous" @click="privateChat" class="private-chat-btn">私聊</span>
    </div>
    <div :class="['info', info.msgTyaope === 3 && 'money']">
      <div class="user">
        <p v-if="info.isAnonymous">
          <span>
            {{ `【匿名】${info.name}` }}
          </span>
        </p>
        <p @click="link('user')" v-else>
          {{ info.company }}
          <span style="color: #666">-{{ info.name }}</span>
        </p>
      </div>
      <div>
        <div
          :class="['bubble', bubblleFold && 'bubblle-fold']"
          :style="{ cursor: tipStyle ? 'pointer' : 'auto' }"
          ref="bubble"
          @click.stop="info.tags && link('detail', { id: info.msgId })"
        >
          <div class="tips" v-if="tipStyle" :style="tipStyle">{{ info.tags }}</div>
          <div class="pre-box" v-if="info.txt" ref="pre" :style="{ maxHeight: bubblleFold ? '100px' : '' }">
            <span v-for="item in info.ats" :key="item.at + item.atName" type="text" class="at-btn" style="padding: 0;">@{{ item.atName }} </span>
            <pre>{{ info.txt }}</pre>
          </div>
          <div class="image-box" v-if="info.imgs && info.imgs.length">
            <div class="image" v-for="(item, index) in info.imgs" :key="index">
              <el-image :src="item" :preview-src-list="info.imgs" fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
          <div class="reply-box" @click="link('detail')" v-if="info.reply">
            <span class="txt text-overflow">回复: {{ info.replyTxt }}</span>
            <span class="btn">详情</span>
          </div>
          <div v-if="bubblleFold" @click.stop="bubblleFold = false" class="show-fold-btn"><span>展开内容</span> <i class="el-icon-arrow-down"></i></div>
        </div>
        <div class="mobile-tag" @click="showMobileDialog" v-if="info.source === 'mobile'">
          <i class="el-icon-mobile-phone"></i>
        </div>
      </div>
      <div class="tool-box">
        <span class="text-btn" @click="$emit('withdraw', info.msgId)" v-if="showWithdraw && direction === 'right'">撤回消息</span>
      </div>
    </div>
  </div>
</template>
<script>
import Tags from "./tags";
import ReportBtn from "./ReportBtn";
import Bus from "@/components/Bus";

export default {
  components: { ReportBtn },
  data() {
    return {
      imageFold: true,
      showWithdraw: false,
      bubblleFold: false
    };
  },
  methods: {
    async privateChat() {
      this.$store.commit("setChatScroll");
      const result = await $.connection.chatConversationHub.server.createConversation(this.info.id);
      const data = {
        id: result.conversationId,
        company: result.company,
        name: result.name,
        userId: result.id
      };
      this.$router.push({
        path: "/conversation",
        query: data
      });
    },
    showMobileDialog() {
      Bus.$emit("showMobileQR");
    },
    clickBtnHandle(type) {
      this.$emit("click-btn", { type, info: this.info });
    },
    link(path, query = {}) {
      // 选择复制的时候不做操作
      if (window.getSelection().toString()) {
        return false;
      }
      this.$store.commit("setChatScroll");
      if (path === "user") {
        const userId = query.id || this.info.id;
        this.$emit("click", { type: "showInfo", userId });
        return true;
      }
      if (this.info.tags || (this.info.reply && path === "detail")) {
        this.$router.push({
          path: `/${path}`,
          query: {
            id: this.info.reply || this.info.msgId
          }
        });
        return true;
      }
      this.$router.push({
        path: `/${path}`,
        query
      });
    }
  },
  computed: {
    direction() {
      let direction = "left";
      if (this.$store.state.userId === this.info.id) {
        direction = "right";
      }
      return direction;
    },
    tipStyle() {
      if (this.info.reply) {
        return null;
      }
      const index = this.types.findIndex(item => item.label === this.info.tags);
      if (index !== -1) {
        return { background: this.types[index].color, cursor: "pointer" };
      }
      return null;
    }
  },
  props: {
    info: {},
    types: {
      type: Array,
      default() {
        return Tags;
      }
    }
  },
  mounted() {
    const diff = this.info.t - Date.now() + 120000;
    if (diff > 0) {
      this.showWithdraw = true;
      setTimeout(() => {
        this.showWithdraw = false;
      }, diff);
    }
    this.$nextTick(() => {
      if (this.$refs.pre && this.$refs.pre.offsetHeight > 100) {
        this.bubblleFold = true;
      }
    });
  }
};
</script>
<style lang="scss">
.m-bubble-message {
  display: flex;
  width: 100%;
  margin-bottom: 15px;

  .el-tag {
    cursor: pointer;
  }
  .el-avatar-box {
    flex-shrink: 0;
    cursor: pointer;
    .private-chat-btn {
      display: block;
      text-align: center;
      font-size: 12px;
      color: #409eff;
    }
  }

  &.direction-right {
    justify-content: flex-end;
    .el-avatar-box .tool-box,
    .private-chat-btn {
      display: none;
    }
    .mobile-tag {
      float: right;
    }
    .user {
      text-align: right;
    }

    .el-avatar-box {
      margin-left: 10px;
      order: 1;
    }

    .bubble {
      float: right;
      &:after {
        left: auto;
        right: -10px;
        border: 5px solid transparent;
        border-left-color: white !important;
      }
    }
  }

  &.direction-left {
    .el-avatar-box {
      margin-right: 10px;
    }
  }

  .recall-btn {
    position: absolute;
    right: 0;
    font-size: 12px;
  }

  .menus-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
  }

  .user {
    color: #000;
    font-size: 12px;
    margin-bottom: 5px;
    line-height: 12px;
    span,
    p {
      cursor: pointer;
    }
  }

  .tool-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: right;
    .text-btn {
      cursor: pointer;
      color: #909399;
      white-space: nowrap;
      font-size: 12px;
    }

    svg {
      cursor: pointer;
      font-size: 14px;
      fill: #b3c2df;
    }
  }

  .tips {
    display: flex;
    padding: 0px 8px;
    width: 100%;
    justify-content: space-between;
    align-items: baseline;
    font-size: 12px;
    color: #fff;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    & + .pre-box {
      padding-top: 5px !important;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    width: 80%;
    > div {
      display: block;
    }
  }

  .money {
    $color: #e74c3c;

    .bubble {
      background: $color;
      color: #fff;

      .tips {
        background-color: $color;
      }

      &:after {
        display: none;
      }
    }
  }
  .mobile-tag {
    //display: none;
    display: inline-flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    float: left;
    margin: 0 5px;
  }

  .bubble {
    position: relative;
    display: block;
    flex-direction: column;
    float: left;
    flex-wrap: wrap;
    border-radius: 4px;
    max-width: 95%;
    box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    font-size: 14px;
    &:after {
      position: absolute;
      left: -10px;
      top: 18px;
      display: block;
      content: "";
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-right-color: white;
    }
    .pre-box + .image-box {
      margin-top: -10px;
    }

    .reply-box {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      width: 100%;
      padding: 5px 10px 10px 10px;
      font-size: 12px;
      color: #999;

      .btn {
        position: absolute;
        right: 20px;
        color: #2288cc;
      }

      .txt {
        display: block;
        width: 100%;
        padding: 5px 40px 5px 10px;
        background-color: #eee;
        border-radius: 4px;
      }
    }

    .pre-box {
      padding: 10px;
      display: block;
      overflow: hidden;

      .el-button {
        padding: 0;
        margin: 0;
        margin-right: 5px;
      }
    }
    .border {
      border: 1px solid #fff;
    }

    .image-box {
      margin: 5px;
      display: flex;
      flex-wrap: wrap;
      .image {
        display: inline-block;
        position: relative;
        width: 100px;
        height: 100px;
        margin: 5px;
      }
    }

    .el-image {
      margin-right: 5px;
      width: 100px;
      height: 100px;
    }
  }
  .bubblle-fold {
    position: relative;
    max-height: 150px;
    .image-box {
      display: none;
    }
    .show-fold-btn {
      cursor: pointer;
      z-index: 10;
      display: flex;
      align-items: center;
      font-size: 12px;
      justify-content: center;
      width: 100%;
      height: 30px;
      line-height: 30px;
      position: absolute;
      text-align: center;
      bottom: 0;
      color: #2288cc;
      background-image: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 1));
      i {
        padding-left: 5px;
      }
    }
  }
  .ai-bubble {
    $bgColor: #ccff90;
    background-color: $bgColor;
    .tips {
      display: none;
    }
    &:after {
      border-right-color: $bgColor;
    }
  }
}
</style>
